module.exports = __webpack_public_path__ + "static/studio_03-b61e977a3e69da1c3dcd607eca53bdad.jpg";